// Central site configuration — update values here and they propagate site-wide.

export const PHONE_NUMBER = "808-301-2134";
export const PHONE_TEL = "tel:808-301-2134";

export const CONTACT_EMAIL = "intake@socialdisputeco.com";

// Direct Stripe Payment Links (frontend bypasses backend for checkout)
export const STRIPE_LINKS = {
  caseReview: "https://buy.stripe.com/00w5kCevV077cse3Wd4F200",
  appealPackage: "https://buy.stripe.com/00w4gy87x6vv3VIgIZ4F203",
  prioritySupport: "https://buy.stripe.com/4gM3cudrR8DD0Jw0K14F202",
};

export const SOCIAL_LINKS = {
  instagram: "https://instagram.com/socialdisputeco",
  x: "https://x.com/socialdisputeco",
  facebook: "https://facebook.com/socialdisputeco",
  youtube: "https://youtube.com/@socialdisputeco",
  linkedin: "https://linkedin.com/company/socialdisputeco",
};

export const LEGAL_ENTITY = {
  dba: "Social Dispute Co",
  llc: "8eight8 LLC",
  city: "Honolulu",
  state: "Hawaii",
  country: "United States",
};
